<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "ChamadoFluxoTransicao"
    }
  },
  data: () => ({
    EtapaList: {}
  }),
  created() {
    this.getEtapaList();
  },
  methods: {
    getEtapaList() {
      api
        .get(`crud/ChamadoFluxoEtapa`)
        .then(response => (this.EtapaList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group
        id="input-group-1"
        label="Nome da ação"
        label-for="nomeAcao"
      >
        <b-form-input
          id="nomeAcao"
          v-model="item.nomeAcao"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Etapa origem"
        label-for="etapaOrigemId"
      >
        <b-form-select
          id="etapaOrigemId"
          v-model="item.etapaIdOrigem"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in EtapaList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.denominacao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Etapa destino"
        label-for="etapaDestinoId"
      >
        <b-form-select
          id="etapaDestinoId"
          v-model="item.etapaIdDestino"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in EtapaList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.denominacao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group id="input-group-1" class="mr-2">
        <b-form-checkbox
          v-model="item.comandadoCliente"
          :disabled="!this.editForm"
          name="check-button"
          switch
        >
          Ação do cliente
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="input-group-1" class="mr-2">
        <b-form-checkbox
          v-model="item.comandadoConsultor"
          :disabled="!this.editForm"
          name="check-button"
          switch
        >
          Ação do consultor
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="input-group-1" class="mr-2">
        <b-form-checkbox
          v-model="item.comentarioObrigatorio"
          :disabled="!this.editForm"
          name="check-button"
          switch
        >
          Comentário obrigatório
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="input-group-1" class="mr-2">
        <b-form-checkbox
          v-model="item.notificaCliente"
          :disabled="!this.editForm"
          name="check-button"
          switch
        >
          Notifica cliente
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="input-group-1" class="mr-2">
        <b-form-checkbox
          v-model="item.notificaConsultor"
          :disabled="!this.editForm"
          name="check-button"
          switch
        >
          Notifica consultor
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
